import React from 'react';
import startCase from 'lodash/startCase';

export default function connectFinalFormField(WrappedComponent: React.SFC<any>) {
  return (props: any) => {
    const { input = undefined, meta = undefined, afterOnChange = () => null, ...rest } = props;
    return (
      <WrappedComponent
        label={input && startCase(input.name)}
        value={input && input.value}
        onChange={(...rest) => {
          input && input.onChange(...rest);
          afterOnChange && afterOnChange(...rest);
        }}
        onBlur={input && input.onBlur}
        onFocus={input && input.onFocus}
        type={input && input.type}
        name={input && input.name}
        dirty={meta && meta.dirty}
        error={meta && meta.touched && meta.error}
        valid={meta && meta.valid}
        active={meta && meta.active}
        {...rest}
      />
    );
  };
}
